import get from 'lodash.get';

const getDpaURL = (rootState) => get(rootState, 'partner.properties.dpaUrl', null);

export default getDpaURL;
